import type { CalendarDate } from './types';

const pad = (n: number, len = 2): string => String(n).padStart(len, '0');

/**
 * Serialize calendar parts to the `YYYY-MM-DD` logical-date wire shape.
 *
 * Deliberately **string arithmetic** — never `.toISOString()`. That reads the
 * UTC date part off what is usually a *local*-midnight instant, which is the
 * previous day in every zone ahead of UTC. A logical date (ADR 024) must never
 * round-trip through an instant.
 *
 * The inverse of {@link parseLogicalDate}.
 *
 * @param date - calendar parts, `month` 1-12 (matching `CalendarDate`).
 * @sideEffect none — pure.
 */
export function toLogicalDateString({ year, month, day }: CalendarDate): string {
    return `${pad(year, 4)}-${pad(month)}-${pad(day)}`;
}
